import React from "react";
import "./EventStats.css";
import {useEventStats} from "./useEventStats";
import EventStatsDashboard from "./eventStats/EventStatsDashboard";
import "./AnalyticsPages.css";

const EventStats: React.FC = () => <EventStatsDashboard data={useEventStats()} />;

export default EventStats;
